import { render } from "./stack_client_r_set_A.vue?vue&type=template&id=b1b2a5d8&scoped=true"
import script from "./stack_client_r_set_A.vue?vue&type=script&lang=js"
export * from "./stack_client_r_set_A.vue?vue&type=script&lang=js"

import "./stack_client_r_set_A.vue?vue&type=style&index=0&id=b1b2a5d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b2a5d8"]])

export default __exports__